import Config from 'common-src/config';

export const AthenaDepartment = {
  NeurologyDanvers: {
    id: 1,
    value: 'Neurology Danvers',
  },
  GUIDE: {
    id: 2,
    value: 'GUIDE',
  },
  NeurologyOrangeCounty: {
    id: 4,
    value: 'Neurology Orange County',
  },
  NeurologyBayArea: {
    id: 5,
    value: 'Neurology Bay Area',
  },
  NeurologyLongBeach: {
    id: 6,
    value: 'Neurology Long Beach',
  },
  TestDepartment: {
    id: 3,
    value: 'Test Department',
  },
};

export const AthenaDepartmentsOptions = Object.values(AthenaDepartment).map((department) => ({
  label: department.value,
  value: department.value,
}));

export const AthenaPracticeOptions = [JSON.parse(Config.ATHENA_MINDSPAN_GROUP_PRACTICE)];

export const AthenaCustomFieldIds = {
  member_id: '32',
  pcp_first_name: '25',
  pcp_last_name: '26',
  pcp_phone_number: '27',
  legacy_patient_id: '1',
};
